export const TRACKING_CONSENT_KEY = 'dotkesk-tracking-consent-v1'
export const TRACKING_CONSENT_EVENT = 'dotkesk:tracking-consent'

export interface TrackingConsent {
  analytics: boolean
  advertising: boolean
}

export function isPublicSitePath(pathname: string) {
  return pathname === '/' || pathname === '/docs' || pathname === '/blog' || pathname.startsWith('/blog/')
}

export function readTrackingConsent(storage: Pick<Storage, 'getItem'> = localStorage): TrackingConsent | null {
  try {
    const raw = storage.getItem(TRACKING_CONSENT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as Partial<TrackingConsent>
    if (typeof parsed.analytics !== 'boolean' || typeof parsed.advertising !== 'boolean') return null
    return { analytics: parsed.analytics, advertising: parsed.advertising }
  } catch {
    return null
  }
}

export function writeTrackingConsent(consent: TrackingConsent, storage: Pick<Storage, 'setItem'> = localStorage) {
  try {
    storage.setItem(TRACKING_CONSENT_KEY, JSON.stringify(consent))
  } catch {
    // Depolama kapalı olsa bile seçim mevcut sayfa oturumunda uygulanır.
  }
  window.dispatchEvent(new CustomEvent<TrackingConsent>(TRACKING_CONSENT_EVENT, { detail: consent }))
}
